// Sales Mutations

export const updateSalesList = (state, payload) => {
  state.salesList = payload
}

export const fetchSaleInfo = (state, payload) => {
  state.saleInfo = payload
}

export const fetchReportUnClosedSalesCount = (state, payload) => {
  state.reportUnclosedSalesCount = payload
}

export const fetchReportUnPaidSalesCount = (state, payload) => {
  state.reportUnPaidSalesCount = payload
}

export const fetchUnClosedSalesCount = (state, payload) => {
  state.unclosedSalesCount = payload
}

export const fetchUnPaidSalesCount = (state, payload) => {
  state.unPaidSalesCount = payload
}
